import CajaMensualDelete from './CajaMensualDelete'
export {CajaMensualDelete}
export default CajaMensualDelete
